import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import {
  useOnboardingPlannerViewSectionContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import { FDStack } from '@facet-wealth/design';
import {
  IncomeInformationSection,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationSection';

function LayoutActivePassiveIncomes() {
  const {
    resource,
  } = useMetaLayoutContext();
  const [sectionDataResource] = resource.attr('sectionData');

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  return (
    <FDStack direction={'column'} paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <FDStack
        direction={'column'}
        spacing={2}
        alignItems={'center'}
        width={'100%'}
        maxWidth={'500px'}
      >
        {sectionDataResource.attr('clientIncomeInformation').resources().list().map((clientIncomeInfo) => (
          <IncomeInformationSection
            key={clientIncomeInfo.id()}
            clientIncomeInformationResource={clientIncomeInfo}
          />
        ))}
      </FDStack>
    </FDStack>
  );
}

LayoutActivePassiveIncomes.propTypes = {
};

LayoutActivePassiveIncomes.defaultProps = {
};

export { LayoutActivePassiveIncomes };
